<template>
  <div>
      <div class="col-md-12 m-0 p-0">
        <div class="col-md-12 d-flex m-0 p-0">
          <b-button
            :variant="currentTab == 'defaulter' ? 'primary' : 'light'"
            class="border-0"
            style="outline:none;box-shadow:none;border-radius:0px"
            @click="changeTab('defaulter')"
          >
            Defaulter
          </b-button>
          <b-button
            :variant="currentTab == 'extend_booking' ? 'primary' : 'light'"
            class="border-0"
            style="outline:none;box-shadow:none;border-radius:0px"
            @click="changeTab('extend_booking')"
          >
            Extend Booking
          </b-button>
        </div>
        <div class="extend" v-if="currentTab == 'extend_booking'">
          <div class="slidecontainer p-4 row">
            <div class="col-md-9 mt-2 d-flex">
              <p class="m-0 p-0">Days:</p>
              <b-form-input
                v-model="daysSelected"
                type="range"
                min="1"
                max="15"
                value="50"
                class="slider mx-2 mt-2"
                id="myRange"
              />
            </div>
            <div class="col-md-3 m-0 p-0">
              <input
                disabled
                type="number"
                class="form-control"
                v-model="daysSelected"
              />
            </div>
          </div>
          <p
            style="fonr-size:12px;color:red"
            class="pl-4 m-0 p-0"
            v-if="model_price == 0"
          >
            Please select Model.
          </p>
          <div class="col-md-12 row pr-4">
            <div class="col-md-6">
              <select v-model="modelSelected" class="form-control p-1 mx-2">
                <option disabled value="0">Select Model</option>
                <option
                  :value="data.id"
                  v-for="(data, index) in models"
                  :key="index"
                >
                  {{ data.name }}
                </option>
              </select>
            </div>
            <div class="col-md-6 text-right pt-2">
              <b-checkbox
                switch
                type="checkbox"
                id="extra"
                :disabled="model_price == 0"
                class="ml-3"
                v-model="helmetRequired"
              >
              Extra Helmet
              </b-checkbox>
            </div>
          </div>
          <div class="breakup card col-md-10 my-4 d-flex" style="margin:0 auto">
            <table class="table table-borderless">
              <thead>
                <tr>
                  <th>Rental Charge</th>
                  <th>{{ Math.round(rentalCharges) | currency }}</th>
                </tr>
                <tr class="border-bot">
                  <th>Helmet</th>
                  <th>{{ helmetrentalCharges | currency }}</th>
                </tr>
                <tr>
                  <th>Total Payable Amount</th>
                  <th>{{ Math.round(payableAmount) | currency }}</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>

        <div class="defaulter" v-if="currentTab == 'defaulter'">
          <div class="slidecontainer p-4 row">
            <div class="col-md-10 mt-2 d-flex">
              <p class="m-0 p-0">Days:</p>
              <b-form-input
                v-model="daysSelectedDefaulter"
                type="range"
                min="1"
                max="30"
                value="50"
                class="slider mx-3 mt-2"
                id="myRange"
              />
            </div>
            <div class="col-md-2">
              <input
                type="number"
                class="form-control"
                v-model="daysSelectedDefaulter"
              />
            </div>
          </div>
          <p
            style="fonr-size:12px;color:red"
            class="pl-4 m-0 p-0"
            v-if="model_price_defaulter == 0"
          >
            Please select model.
          </p>
          <div class="col-md-12 row pr-4">
            <div class="col-md-6">
              <select
                v-model="modelSelectedDefaulter"
                class="form-control p-1 mx-2"
              >
                <option disabled value="0">Select Model</option>
                <option
                  :value="data.id"
                  v-for="(data, index) in models"
                  :key="index"
                >
                  {{ data.name }}
                </option>
              </select>
            </div>
            <div class="col-md-6 text-right pt-2">
              <b-checkbox
                switch
                type="checkbox"
                id="extra"
                :disabled="model_price_defaulter == 0"
                class="ml-3"
                v-model="helmetRequiredDefaulter"
              >
              Extra Helmet
              </b-checkbox>
            </div>
          </div>
          <div class="breakup card col-md-10 my-4 d-flex" style="margin:0 auto">
            <table class="table table-borderless">
              <thead>
                <tr>
                  <th>Rental Charge</th>
                  <th>{{ Math.round(rentalChargesDefaulter) | currency }}</th>
                </tr>
                <tr>
                  <th>Helmet</th>
                  <th>{{ helmetrentalChargesdefaulter | currency }}</th>
                </tr>
                <tr class="border-bot">
                  <th>Penalty</th>
                  <th>{{ penaltyrentalChargesdefaulter | currency }}</th>
                </tr>
                <tr>
                  <th>Total Payable Amount</th>
                  <th>{{ payableAmountdefaulter | currency }}</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
 data() {
     return { 
      currentTab: "defaulter",
      daysSelected: 7,
      helmetRequired: false,
      model_price: 0,
      daysSelectedDefaulter: 15,
      helmetRequiredDefaulter: false,
      model_price_defaulter: 0,
      modelSelected:'',
      modelSelectedDefaulter:'',
     }
 },
 created () {this.$store.dispatch("get_models");},
 watch: {
    modelSelected(){
        var x  = this.models.filter(x=>{
          return x.id == this.modelSelected
        })
        this.model_price = Number(x[0].price)
    },
    modelSelectedDefaulter(){
        var x  = this.models.filter(x=>{
          return x.id == this.modelSelectedDefaulter
        })
        this.model_price_defaulter = Number(x[0].price)
    },
    models(){
      this.modelSelected = this.models[0].id
      this.modelSelectedDefaulter = this.models[0].id
    }
 },
 methods: {
   changeTab(id) {
      this.currentTab = id;
    },
 },
 computed: {
    models() {
      return this.$store.state.models_list;
    },
    rental() {
      return (this.model_price * (1.95 - 0.05 * this.daysSelected)) / 30;
    },
    rentalCharges() {
      return this.rental * this.daysSelected;
    },
    helmetrental() {
      if (this.helmetRequired) {
        return (300 * (1.95 - 0.05 * this.daysSelected)) / 30;
      } else {
        return 0;
      }
    },
    helmetrentalCharges() {
      return this.helmetrental * this.daysSelected;
    },
    payableAmount() {
      return Math.round(this.helmetrentalCharges + this.rentalCharges);
    },
    rentalChargesDefaulter() {
      return (this.model_price_defaulter / 30) * this.daysSelectedDefaulter;
    },
    helmetrentalChargesdefaulter() {
      if (!this.helmetRequiredDefaulter) {
        return 0;
      } else {
        return (300 / 30) * this.daysSelectedDefaulter;
      }
    },
    penaltyrentalChargesdefaulter() {
      return this.daysSelectedDefaulter * 100;
    },
    payableAmountdefaulter() {
      return (
        this.helmetrentalChargesdefaulter +
        this.penaltyrentalChargesdefaulter +
        this.rentalChargesDefaulter
      );
    },
 }
}
</script>

<style>

</style>